define('lq/events/actions/calendarURLExport',[
    'lq',
    'lq/events/actions/eventAction'
], function (lq, EventAction) {
    'use strict';

    var prepareParameter = function(value) {
        return encodeURIComponent(btoa(value));
    };

    function CalendarURLExport(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CalendarURLExport, EventAction);

    CalendarURLExport.typeName = 'CalendarURLExport';

    CalendarURLExport.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CalendarURLExport.prototype.execute = function (continuation) {
        var fullUrl = this.getFullUrl().replace(/https?:\/\//, 'webcal://');

        if (this.eventData.targetParameter)
            this.piping.parameters.locals.setValue(this.eventData.targetParameter, fullUrl);

        if (this.eventData.open) {
            window.location.href = fullUrl;
        }
        
        continuation();
    };

    CalendarURLExport.prototype.getFullUrl = function () {
        var url = lq.getTenantUrl('Export/Calendar/' + prepareParameter(this.piping.actionId) + '/' + prepareParameter(this.eventData.command)) + '/';

        if (this.eventData.identifierParameter) {
            var parameterValue = this.piping.parameters.getValue(this.eventData.identifierParameter);
            if (parameterValue) url += prepareParameter(parameterValue);
        }

        return lq.getFullUrl(url);
    };

    return CalendarURLExport;
});
